import { GatewayAssujetti } from "@conformite/gateway";
import { userSession } from "@src/data/session/UserSession";

export class AssujettiApi {
  static async list(
    millesime: number,
    siren: string
  ): Promise<GatewayAssujetti.ListAssujettiWithAvancementResponseType> {
    const { data } =
      await userSession.axiosInstance.get<GatewayAssujetti.ListAssujettiWithAvancementAndTotalResponseType>(
        `${GatewayAssujetti.listAssujettiUrl}/${millesime}/${siren}/admin`
      );
    return data.assujettis;
  }
}
